import { TableHeader as UITableHeader, TableRow } from "@/components/ui/table";
import { HeaderGroup } from "@tanstack/react-table";
import { Cell } from "./Cell";
import { ListLayoutProps } from "@/types/list";

export const TableHeader = <TData,>({
	headerGroups,
	layout,
}: {
	headerGroups: HeaderGroup<TData>[];
	layout: ListLayoutProps;
}) => {
	return (
		<UITableHeader>
			{headerGroups.map(group => (
				<HeaderRow key={group.id} headerGroup={group} layout={layout} />
			))}
		</UITableHeader>
	);
};

const HeaderRow = <TData,>({ headerGroup, layout }: { headerGroup: HeaderGroup<TData>; layout: ListLayoutProps }) => (
	<TableRow key={headerGroup.id}>
		{headerGroup.headers.map(header => (
			<Cell key={header.id} header={header} layout={layout} />
		))}
	</TableRow>
);
